import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import GeneralAuthentication from "../general/GeneralAuthentication";
import { getBrokerInformation } from "../store/broker";
import TwoPanesPanel from "../general/TwoPanesPanel";
import MainPane from "../general/MainPane";
import LeftPaneGeneral from "../general/LeftPaneGeneral";
import BackToApplication from "../general/BackToApplication";
import { TwoHeading } from "../general/TwoHeading";
import * as theme from "../theme";
import {
  getGettingMyBinders,
  getGettingMyBindersSuccess,
  getMyBinders,
  getStatus,
  getBrokers,
  getVertical,
  getRowDetailsFromProspectId,
  getFilteredProspectsIdArray,
  searchProspects,
  getSearchedProspectsArray,
  getGettingMyBindersFailed,
} from "../store/mybinder";
import { useNavigate } from "react-router-dom";
import { getPolicyStatusData } from "../store/policyStatus";
import { getStatusApi } from "../store/policyStatus";
import Loader3Orange from "../general/Loader3Orange";
import { getScrollResponsesDiv } from "../store/quotes";
import FormControl from "@material-ui/core/FormControl";
import { makeStyles } from "@material-ui/core/styles";
import NormalText from "../general/NormalText";
import { activateNavigationPage, getLanguageCode } from "../store/components";
import {
  Client_Business_name,
  Client_Contact,
  Client_Email,
  Client_Name,
} from "../store/permanentQues";
import { OrangeButton } from "../general/OrangeButton";
import moment from "moment";
import { PossibleNaviationPages } from "./Navigation";
import Typography from "@material-ui/core/Typography";
import DateFnsUtils from "@date-io/date-fns";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import Select from "react-dropdown-select";
import { capitalizeFirstLetter } from "../utils/utils";
import translations from "../utils/translations";
import "moment/locale/fr"; // Import French locale data
import frLocale from "date-fns/locale/fr";
import enLocale from "date-fns/locale/en-US";
import { getTranslatedOptions,statusOptionList } from "../helper/constants";


const useStyles = makeStyles(theme.customMaterialUIClassForScrollBar);

const BindPolicies = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      activateNavigationPage({ pagecode: PossibleNaviationPages.mypolicies })
    );
  }, [dispatch]);
  const [query, setQuery] = useState("");
  const [brokerFilter, setBrokerFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [verticalFilter, setVerticalFilter] = useState("");
  const [startDateFilter, setStartDateFilter] = useState(null);
  const [endDateFilter, setEndDateFilter] = useState(null);
  const [showBoardView, setBoardViewVisbility] = useState(false);
  return (
    <GeneralAuthentication>
      <MainPane hideHelpOrTip={true}>
        <TwoPanesPanel
          overflowY={"hidden"}
          myquotesscreen={true}
          myquotesleftpane={
            showBoardView ? (
              <BoardView
                query={query}
                brokerFilter={brokerFilter}
                statusFilter={statusFilter}
                verticalFilter={verticalFilter}
                startDateFilter={startDateFilter}
                endDateFilter={endDateFilter}
                setBoardViewVisbility={setBoardViewVisbility}
              />
            ) : (
              <MyBindersLeftPane
                query={query}
                brokerFilter={brokerFilter}
                statusFilter={statusFilter}
                verticalFilter={verticalFilter}
                startDateFilter={startDateFilter}
                endDateFilter={endDateFilter}
                setBoardViewVisbility={setBoardViewVisbility}
              />
            )
          }
          myquotesrightpane={
            <MyBindersRightPane
              setQuery={setQuery}
              query={query}
              startDateFilter={startDateFilter}
              endDateFilter={endDateFilter}
              setBrokerFilter={setBrokerFilter}
              setStatusFilter={setStatusFilter}
              setVerticalFilter={setVerticalFilter}
              setStartDateFilter={setStartDateFilter}
              setEndDateFilter={setEndDateFilter}
            />
          }
        ></TwoPanesPanel>
      </MainPane>
    </GeneralAuthentication>
  );
};

//#region  Left Pane

const MyBindersLeftPane = (props) => {
  let heightDivison = {
    backtoapp: "9%",
    quoteresults: "11%",
    tableheader: "75px",
    bottommargin: "4vmin",
    spaceBetweenHeaderContent: "0px",
    responses: "",
  };

  heightDivison.responses = `calc(100% - ${heightDivison.backtoapp} - ${heightDivison.quoteresults} - ${heightDivison.tableheader} - ${heightDivison.bottommargin} - ${heightDivison.spaceBetweenHeaderContent})`;
  const mainContMargin = "5vw";
  const navigate = useNavigate();
  const broker = useSelector(getBrokerInformation);
  const languagepreference = broker.information.languagepreference || "en";
  return (
    <LeftPaneGeneral
      heightDivison={heightDivison}
      backToApplication={
        <BackToApplication
          text={translations[languagepreference]?.backToHomePage}
          onClick={() => {
            navigate(`/`);
          }}
        ></BackToApplication>
      }
      headingSection={
        <div
          style={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <TwoHeading
            heading1={translations[languagepreference]?.binderTitle}
            heading2={translations[languagepreference]?.binderSubInfo}
          ></TwoHeading>
        </div>
      }
      tableHeaderSection={<MyBindersTableHeader></MyBindersTableHeader>}
      tableRowsSection={
        // <div style={{ width: "100%", height: "100vh" }}></div>
        <MyBindersRowsSection heightDivison={heightDivison}>
          <MyBindersEachRow
            query={props.query}
            brokerFilter={props.brokerFilter}
            statusFilter={props.statusFilter}
            verticalFilter={props.verticalFilter}
            startDateFilter={props.startDateFilter}
            endDateFilter={props.endDateFilter}
            heightDivison={heightDivison}
            mainContMargin={mainContMargin}
          ></MyBindersEachRow>
        </MyBindersRowsSection>
      }
    ></LeftPaneGeneral>
  );
};

const SomethingFailedGettingMyBinders = () => {
  return <div>Something failed getting my quotes, please contact admin.</div>;
};

const MyBindersRowsSection = (props) => {
  const dispatch = useDispatch();
  const { heightDivison } = props;

  const gettingMyBindersInitialized = useSelector(getGettingMyBinders);
  const gettingMyBindersSucceed = useSelector(getGettingMyBindersSuccess);
  const gettingMyBindersFailed = useSelector(getGettingMyBindersFailed);

  const data = useSelector(getPolicyStatusData);

  useEffect(() => {
    dispatch(getStatusApi());
  }, [dispatch]);
  const policyStatusData = useSelector(getPolicyStatusData);
  useEffect(() => {
    let statusid = "";
    policyStatusData &&
      policyStatusData?.policystatus?.map((status) => {
        if (status.name === "BINDER") {
          statusid = status._id;
          return [];
        }
      });
    if (statusid !== "") {
      dispatch(
        getMyBinders({
          statusid,
        })
      );
    }
  }, [dispatch, policyStatusData]);

  return (
    <>
      {gettingMyBindersInitialized ? (
        <div
          style={{
            width: "100%",
            height: heightDivison.responses,
          }}
        >
          <Loader3Orange></Loader3Orange>
        </div>
      ) : gettingMyBindersSucceed ? (
        props.children
      ) : (
        gettingMyBindersFailed && (
          <SomethingFailedGettingMyBinders></SomethingFailedGettingMyBinders>
        )
      )}
    </>
  );
};

const MyBindersEachRow = (props) => {
  const isScrollResponsesDiv = useSelector(getScrollResponsesDiv);
  const searchedProspects = useSelector(getSearchedProspectsArray);
  const prospectfilteredorder = useSelector(
    getFilteredProspectsIdArray(
      props.brokerFilter,
      props.statusFilter,
      props.verticalFilter,
      props.startDateFilter,
      props.endDateFilter,
      searchedProspects
    )
  );
  const responsesDiv = useRef(null);
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const ColoumnWidth = theme.columnWidthMyBinderTable;
  ColoumnWidth.sixth = `calc(100% - ${ColoumnWidth.first} - ${ColoumnWidth.second} - ${ColoumnWidth.third} - ${ColoumnWidth.fourth} - ${ColoumnWidth.fifth} - ${ColoumnWidth.seventh} - ${ColoumnWidth.eighth} - ${ColoumnWidth.ninth})`;
  const classes = useStyles();
  const itemsPerPage = 10;
  const maxPages = 10;

  // Logic for displaying page numbers
  const pageNumbers = [];
  const totalPages = Math.ceil(prospectfilteredorder.length / itemsPerPage);
  const arrPageLimiter = [totalPages, maxPages];
  for (let i = 1; i <= Math.min(...arrPageLimiter); i++) {
    pageNumbers.push(i);
  }

  return (
    <div
      style={{
        width: "100%",
        height: props.heightDivison.responses,
        paddingLeft: props.mainContMargin,
        paddingRight: isScrollResponsesDiv
          ? `calc(${props.mainContMargin} - ${theme.SCALES.scrollbarThickness} - ${theme.SCALES.responsesSpacesBetweenScroll})`
          : props.mainContMargin,
      }}
    >
      <div
        className={classes.responses}
        style={{
          width: "100%",
          paddingRight: isScrollResponsesDiv
            ? theme.SCALES.responsesSpacesBetweenScroll
            : "0px",
          height: "100%",
          overflow: "auto",
        }}
        ref={responsesDiv}
      >
        {prospectfilteredorder.map((prospectid, x) =>
          x >= (currentPage - 1) * itemsPerPage &&
          x < currentPage * itemsPerPage ? (
            <ProspectRow key={x} prospectid={prospectid}></ProspectRow>
          ) : null
        )}
      </div>
      <div>
        <ul className="pagination justify-content-center">
          {pageNumbers.map((x) => (
            <li
              key={x}
              className={x === currentPage ? "page-item active" : "page-item"}
            >
              <a
                className="page-link"
                onClick={() => {
                  setCurrentPage(x);
                }}
              >
                {x}
              </a>
            </li>
          ))}
          {totalPages > maxPages ? (
            <li
              key={totalPages}
              className={
                totalPages === currentPage ? "page-item active" : "page-item"
              }
            >
              <input
                className="page-link"
                style={{ width: "80px" }}
                placeholder={".." + totalPages}
                type="number"
                min="1"
                max={totalPages}
                onChange={(event) => {
                  setCurrentPage(event.target.value);
                }}
              ></input>
            </li>
          ) : null}
        </ul>
      </div>
    </div>
  );
};

const ProspectRow = ({ prospectid }) => {
  // const prospectDetails = useSelector(getMyBinderList);
  const prospectDetails = useSelector(
    getRowDetailsFromProspectId({ prospectid })
  );
  const statusTranslations = {
    New: {
      fr: "Nouveau",
    },
    "App In Progress": {
      fr: "En cours",
    },
    "Close - Incomplete info": {
      fr: "Fermé - Informations incomplètes",
    },
    "App Completed": {
      fr: "Application terminée",
    },
    "In Market": {
      fr: "Sur le marché",
    },
    "Close - No Insurer": {
      fr: "Fermé - Aucun assureur",
    },
    Quoted: {
      fr: "Devis fourni",
    },
    "Not Interested": {
      fr: "Pas intéressé",
    },
    Sold: {
      fr: "Vendu",
    },
  };

  function translateStatus(status, langPref) {
    if (statusTranslations[status] && statusTranslations[status][langPref]) {
      return statusTranslations[status][langPref];
    } else {
      // Handle cases where the status or language preference is not found
      console.warn(
        `No translation found for status "${status}" and language "${langPref}". Returning original status.`
      );
      return status; // Or you could return a default translation
    }
  }
  const searchedProspects = useSelector(getSearchedProspectsArray);
  const brokerage = useSelector(getBrokerInformation);
  const languagepreference = brokerage.information.languagepreference || "en";
  const ColoumnWidth = theme.columnWidthMyBinderTable;
  ColoumnWidth.sixth = `calc(100% - ${ColoumnWidth.first} - ${ColoumnWidth.second} - ${ColoumnWidth.third}  - ${ColoumnWidth.fifth} - ${ColoumnWidth.seventh} - ${ColoumnWidth.eighth} - ${ColoumnWidth.ninth})`;
  const navigate = useNavigate();
  const commonStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  };

  const borderCommon = {
    borderRight: "1px solid #D8D8D8",
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        width: "100%",
        height: "60px",
        maxHeight: 75,
        borderBottom: "1px solid " + theme.COLORS.tertiary_ligthindigo,
        borderTop: "1px solid " + theme.COLORS.tertiary_ligthindigo,
        backgroundColor: "white",
      }}
    >
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.first,
          ...borderCommon,
        }}
      >
        <NormalText
          text={prospectDetails.brokername}
          fontWeight={"normal"}
          fontSize={15}
          color="grey"
        ></NormalText>
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.second,
          ...borderCommon,
        }}
      >
        <ClientDetailsGeneral
          prospectDetails={prospectDetails}
          ClientDetailPartName={Client_Name}
        ></ClientDetailsGeneral>
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.third,
          ...borderCommon,
        }}
      >
        <NormalText
          text={prospectDetails.vertical[languagepreference]}
          fontWeight={"normal"}
          fontSize={15}
          color="grey"
        ></NormalText>
      </div>
      {/* <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.fourth,
          ...borderCommon,
        }}
      >
        <ClientDetailsGeneral
          prospectDetails={prospectDetails}
          ClientDetailPartName={Client_Name}
        ></ClientDetailsGeneral>
      </div> */}
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.fifth,
          ...borderCommon,
        }}
      >
        <a
          href={
            "tel:" +
            prospectDetails.clientdetails[Client_Contact]?.replace(
              /[^0-9]+/g,
              ""
            )
          }
        >
          <ClientDetailsGeneral
            prospectDetails={prospectDetails}
            ClientDetailPartName={Client_Contact}
          ></ClientDetailsGeneral>
        </a>
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.sixth,
          ...borderCommon,
        }}
      >
        <a href={"mailto:" + prospectDetails.clientdetails[Client_Email]}>
          <ClientDetailsGeneral
            prospectDetails={prospectDetails}
            ClientDetailPartName={Client_Email}
          ></ClientDetailsGeneral>
        </a>
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.seventh,
          ...borderCommon,
        }}
      >
        <NormalText
          text={translateStatus(
            capitalizeFirstLetter(prospectDetails.prospectstatus),
            languagepreference
          )}
          fontWeight={"normal"}
          fontSize={15}
          color="grey"
        ></NormalText>
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.eighth,
          ...borderCommon,
        }}
      >
        <FormattedDate
          milliseconds={prospectDetails.prospectlastupdated}
          languagepreference={languagepreference}
        ></FormattedDate>
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.ninth,
        }}
      >
        <OrangeButton
          text={translations[languagepreference]?.review}
          color={theme.COLORS.primary_navyblue}
          onClick={() => {
            //navigate(`/binder?id=${prospectid}`)
            document.location.href = `/binder?id=${prospectid}`;
          }}
        ></OrangeButton>
      </div>
    </div>
  );
};

const FormattedDate = ({ milliseconds, languagepreference }) => {
  let date = new Date(milliseconds);
  let dateFormatted = moment(date)
    .locale(languagepreference)
    .format("DD MMM YYYY");

  return (
    <NormalText
      text={dateFormatted}
      fontWeight={"normal"}
      fontSize={15}
      color="grey"
    ></NormalText>
  );
};

const FormateDate = ({ millliseconds }) => {
  let date = new Date(millliseconds);
  let dateFormatted = moment(date, "DD/MM/YYYY").format("DD MMM YYYY");
  return (
    <NormalText
      text={dateFormatted}
      fontWeight={"normal"}
      fontSize={15}
      color="grey"
    ></NormalText>
  );
};

const ClientDetailsGeneral = ({
  prospectDetails,
  ClientDetailPartName,
  textColor,
  fontSize,
}) => {
  const [show, setShow] = useState(false);
  if (!textColor) textColor = "grey";
  if (!fontSize) fontSize = 15;
  useEffect(() => {
    const timeout = setTimeout(() => setShow(true), 50);
    return () => clearTimeout(timeout);
  });

  return (
    <>
      {show ? (
        <NormalText
          text={prospectDetails[ClientDetailPartName]}
          fontWeight={"normal"}
          fontSize={fontSize}
          color={textColor}
        ></NormalText>
      ) : (
        ""
      )}
    </>
  );
};

const MyBindersTableHeader = (props) => {
  const ColoumnWidth = theme.columnWidthMyBinderTable;
  ColoumnWidth.sixth = `calc(100% - ${ColoumnWidth.first} - ${ColoumnWidth.second} - ${ColoumnWidth.third}  - ${ColoumnWidth.fifth} - ${ColoumnWidth.seventh} - ${ColoumnWidth.eighth} - ${ColoumnWidth.ninth})`;
  const translations = {
    // **New Translations for Column Headings**
    en: {
      columnHeadingsQuotes: {
        first: "Broker",
        second: "Client",
        third: "Vertical",
        // fourth: "Contact Name",
        fifth: "Contact Number",
        sixth: "Contact Email",
        seventh: "Status",
        eighth: "Last Update",
        ninth: "Review Details",
      },
    },
    fr: {
      columnHeadingsQuotes: {
        first: "Courtier",
        second: "Client",
        third: "Secteur d’activités",
        // fourth: "Nom du contact",
        fifth: "Téléphone du contact",
        sixth: "Courriel du contact",
        seventh: "Statut",
        eighth: "Dernière Mise à Jour",
        ninth: "Réviser les détails",
      },
    },
  };
  const brokerage = useSelector(getBrokerInformation);
  const languagepreference = brokerage.information.languagepreference || "en";
  const columnHeadingsQuotes = {
    first:
      translations[languagepreference]?.columnHeadingsQuotes.first ||
      translations["en"].columnHeadingsQuotes.first,
    second:
      translations[languagepreference]?.columnHeadingsQuotes.second ||
      translations["en"].columnHeadingsQuotes.second,
    third:
      translations[languagepreference]?.columnHeadingsQuotes.third ||
      translations["en"].columnHeadingsQuotes.third,
    fourth:
      translations[languagepreference]?.columnHeadingsQuotes.fourth ||
      translations["en"].columnHeadingsQuotes.fourth,
    fifth:
      translations[languagepreference]?.columnHeadingsQuotes.fifth ||
      translations["en"].columnHeadingsQuotes.fifth,
    sixth:
      translations[languagepreference]?.columnHeadingsQuotes.sixth ||
      translations["en"].columnHeadingsQuotes.sixth,
    seventh:
      translations[languagepreference]?.columnHeadingsQuotes.seventh ||
      translations["en"].columnHeadingsQuotes.seventh,
    eighth:
      translations[languagepreference]?.columnHeadingsQuotes.eighth ||
      translations["en"].columnHeadingsQuotes.eighth,
    ninth:
      translations[languagepreference]?.columnHeadingsQuotes.ninth ||
      translations["en"].columnHeadingsQuotes.ninth,
  };

  const CommonStyleColumn = {
    color: "white",
    fontFamily: "GibsonRegular",
    alignSelf: "center",
    borderRight: `1px solid ${theme.COLORS.table_header_border}`,
    height: "100%",
    display: "flex",
    alignItems: "center",
    letterSpacing: 1,
    justifyContent: "center",
    textAlign: "center",
    fontSize: "1.5vmin",
  };
  const BorderRaidus = 8;
  const headingStyle = {
    height: "77%",
    width: "100%",
    backgroundColor: theme.COLORS.secondary_skyblue,
    borderTopLeftRadius: BorderRaidus,
    borderTopRightRadius: BorderRaidus,
    display: "flex",
    flexDirection: "row",
  };

  return (
    <div style={headingStyle}>
      <div style={{ width: ColoumnWidth.first, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.first}
      </div>
      <div style={{ width: ColoumnWidth.second, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.second}
      </div>
      <div style={{ width: ColoumnWidth.third, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.third}
      </div>
      <div
        style={{
          width: ColoumnWidth.fourth,
          ...CommonStyleColumn,
        }}
      >
        {columnHeadingsQuotes.fourth}
      </div>
      <div style={{ width: ColoumnWidth.fifth, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.fifth}
      </div>
      <div style={{ width: ColoumnWidth.sixth, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.sixth}
      </div>
      <div style={{ width: ColoumnWidth.seventh, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.seventh}
      </div>
      <div style={{ width: ColoumnWidth.eighth, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.eighth}
      </div>

      <div
        style={{
          width: ColoumnWidth.ninth,
          ...CommonStyleColumn,
          borderRight: 0,
        }}
      >
        {columnHeadingsQuotes.ninth}
      </div>
    </div>
  );
};
//#endregion

const BoardView = (props) => {
  let heightDivison = {
    backtoapp: "9%",
    quoteresults: "11%",
    tableheader: "75px",
    bottommargin: "4vmin",
    spaceBetweenHeaderContent: "0px",
    responses: "",
  };
  const brokerage = useSelector(getBrokerInformation);
  const languagepreference = brokerage.information.languagepreference || "en";

  heightDivison.responses = `calc(100% - ${heightDivison.backtoapp} - ${heightDivison.quoteresults} - ${heightDivison.tableheader} - ${heightDivison.bottommargin} - ${heightDivison.spaceBetweenHeaderContent})`;
  const mainContMargin = "5vw";
  const navigate = useNavigate();
  return (
    <LeftPaneGeneral
      heightDivison={heightDivison}
      backToApplication={
        <BackToApplication
          text={translations[languagepreference]?.backToHomePage}
          onClick={() => {
            //navigate(`/`);
            document.location.href = `/`;
          }}
        ></BackToApplication>
      }
      headingSection={
        <div
          style={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <TwoHeading
            heading1={"Your Prospects"}
            heading2={
              "Filter below, or scroll through all your client activity"
            }
          ></TwoHeading>
          <OrangeButton
            onClick={() => props.setBoardViewVisbility(false)}
            width="12.5vw"
            fontSize="2vh"
            text="Details View"
          />
        </div>
      }
      tableHeaderSection={<BoardTableHeader></BoardTableHeader>}
      tableRowsSection={
        // <div style={{ width: "100%", height: "100vh" }}></div>
        <BoardRowsSection heightDivison={heightDivison}>
          <BoardEachRow
            query={props.query}
            brokerFilter={props.brokerFilter}
            statusFilter={props.statusFilter}
            verticalFilter={props.verticalFilter}
            startDateFilter={props.startDateFilter}
            endDateFilter={props.endDateFilter}
            heightDivison={heightDivison}
            mainContMargin={mainContMargin}
          ></BoardEachRow>
        </BoardRowsSection>
      }
    ></LeftPaneGeneral>
  );
};

const BoardTableHeader = (props) => {
  const ColoumnWidth = theme.columnWidthMyBinderTable;

  const columnHeadingsQuotes = {
    first: "New",
    second: "App In Progress",
    third: "App Completed",
    fourth: "In Market",
    fifth: "Quoted",
    sixth: "Sold",
    seventh: "Close - Incomplete Info",
    eighth: "Close - No Insurer",
    ninth: "Not Interested",
  };

  const CommonStyleColumn = {
    color: "white",
    fontFamily: "GibsonRegular",
    alignSelf: "center",
    borderRight: `1px solid ${theme.COLORS.table_header_border}`,
    height: "100%",
    display: "flex",
    alignItems: "center",
    letterSpacing: 1,
    justifyContent: "center",
    textAlign: "center",
    fontSize: "1.5vmin",
  };
  const BorderRaidus = 8;
  const headingStyle = {
    height: "77%",
    width: "100%",
    backgroundColor: theme.COLORS.secondary_skyblue,
    borderTopLeftRadius: BorderRaidus,
    borderTopRightRadius: BorderRaidus,
    display: "flex",
    flexDirection: "row",
  };

  return (
    <div style={headingStyle}>
      <div style={{ width: ColoumnWidth.first, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.first}
      </div>
      <div style={{ width: ColoumnWidth.second, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.second}
      </div>
      <div style={{ width: ColoumnWidth.third, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.third}
      </div>
      <div
        style={{
          width: ColoumnWidth.fourth,
          ...CommonStyleColumn,
        }}
      >
        {columnHeadingsQuotes.fourth}
      </div>
      <div style={{ width: ColoumnWidth.fifth, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.fifth}
      </div>
      <div style={{ width: ColoumnWidth.sixth, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.sixth}
      </div>
      <div style={{ width: ColoumnWidth.seventh, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.seventh}
      </div>
      <div style={{ width: ColoumnWidth.eighth, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.eighth}
      </div>

      <div
        style={{
          width: ColoumnWidth.ninth,
          ...CommonStyleColumn,
          borderRight: 0,
        }}
      >
        {columnHeadingsQuotes.ninth}
      </div>
    </div>
  );
};

const BoardRowsSection = (props) => {
  const dispatch = useDispatch();
  const { heightDivison } = props;

  const gettingMyBindersInitialized = useSelector(getGettingMyBinders);
  const gettingMyBindersSucceed = useSelector(getGettingMyBindersSuccess);
  const gettingMyBindersFailed = useSelector(getGettingMyBindersFailed);

  // useEffect(() => {
  //   dispatch(getBinderDetailsUsingProspectId(null));
  // }, [dispatch]);

  return (
    <>
      {gettingMyBindersInitialized ? (
        <div
          style={{
            width: "100%",
            height: heightDivison.responses,
          }}
        >
          <Loader3Orange></Loader3Orange>
        </div>
      ) : gettingMyBindersSucceed ? (
        props.children
      ) : (
        gettingMyBindersFailed && (
          <SomethingFailedGettingMyBinders></SomethingFailedGettingMyBinders>
        )
      )}
    </>
  );
};

const BoardEachRow = (props) => {
  const isScrollResponsesDiv = useSelector(getScrollResponsesDiv);
  const searchedProspects = useSelector(getSearchedProspectsArray);
  const prospectfilteredorder = useSelector(
    getFilteredProspectsIdArray(
      props.brokerFilter,
      props.statusFilter,
      props.verticalFilter,
      props.startDateFilter,
      props.endDateFilter,
      searchedProspects
    )
  );
  const responsesDiv = useRef(null);
  const dispatch = useDispatch();

  const classes = useStyles();

  return (
    <div
      style={{
        width: "100%",
        height: props.heightDivison.responses,
        paddingLeft: props.mainContMargin,
        paddingRight: isScrollResponsesDiv
          ? `calc(${props.mainContMargin} - ${theme.SCALES.scrollbarThickness} - ${theme.SCALES.responsesSpacesBetweenScroll})`
          : props.mainContMargin,
      }}
    >
      <div
        className={classes.responses}
        style={{
          width: "100%",
          paddingRight: isScrollResponsesDiv
            ? theme.SCALES.responsesSpacesBetweenScroll
            : "0px",
          height: "100%",
          overflow: "auto",
        }}
        ref={responsesDiv}
      >
        {prospectfilteredorder.slice(0, 100).map((prospectid, index) => (
          <BoardRow key={index} prospectid={prospectid}></BoardRow>
        ))}
      </div>
    </div>
  );
};

const BoardRow = ({ prospectid }) => {
  const prospectDetails = useSelector(
    getRowDetailsFromProspectId({ prospectid })
  );
  const searchedProspects = useSelector(getSearchedProspectsArray);
  const brokerage = useSelector(getBrokerInformation);
  const languagepreference = brokerage.information.languagepreference || "en";
  const navigate = useNavigate();
  const ColoumnWidth = theme.columnWidthMyBinderTable;

  const commonStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const borderCommon = {
    borderRight: "1px solid #D8D8D8",
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        width: "100%",
        height: "60px",
        maxHeight: 75,
        borderBottom: "1px solid " + theme.COLORS.tertiary_ligthindigo,
        borderTop: "1px solid " + theme.COLORS.tertiary_ligthindigo,
        backgroundColor: "white",
      }}
    >
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.first,
          ...borderCommon,
        }}
      >
        {prospectDetails.status == "new" || prospectDetails.status == "New" ? (
          <div
            style={{
              backgroundColor: "gray",
              borderRadius: "5px",
              border: "1px solid lightgray",
              height: "100%",
              width: "100%",
              ...commonStyle,
              flexDirection: "column",
              cursor: "pointer",
            }}
            onClick={() => {
              //navigate(`/binder?id=${prospectid}`)
              document.location.href = `/binder?id=${prospectid}`;
            }}
          >
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Name}
                textColor="white"
                fontSize={15}
              ></ClientDetailsGeneral>
            </div>
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Business_name}
                textColor="white"
                fontSize={10}
              ></ClientDetailsGeneral>
            </div>
          </div>
        ) : (
          <div />
        )}
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.second,
          ...borderCommon,
        }}
      >
        {prospectDetails.status == "App In Progress" ? (
          <div
            style={{
              backgroundColor: "gray",
              borderRadius: "5px",
              border: "1px solid lightgray",
              height: "100%",
              width: "100%",
              ...commonStyle,
              flexDirection: "column",
              cursor: "pointer",
            }}
            onClick={() => {
              //navigate(`/binder?id=${prospectid}`)
              document.location.href = `/binder?id=${prospectid}`;
            }}
          >
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Name}
                textColor="white"
                fontSize={15}
              ></ClientDetailsGeneral>
            </div>
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Business_name}
                textColor="white"
                fontSize={10}
              ></ClientDetailsGeneral>
            </div>
          </div>
        ) : (
          <div />
        )}
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.third,
          ...borderCommon,
        }}
      >
        {prospectDetails.status == "App Completed" ? (
          <div
            style={{
              backgroundColor: "gray",
              borderRadius: "5px",
              border: "1px solid lightgray",
              height: "100%",
              width: "100%",
              ...commonStyle,
              flexDirection: "column",
              cursor: "pointer",
            }}
            onClick={() => {
              //navigate(`/binder?id=${prospectid}`)
              document.location.href = `/binder?id=${prospectid}`;
            }}
          >
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Name}
                textColor="white"
                fontSize={15}
              ></ClientDetailsGeneral>
            </div>
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Business_name}
                textColor="white"
                fontSize={10}
              ></ClientDetailsGeneral>
            </div>
          </div>
        ) : (
          <div />
        )}
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.fourth,
          ...borderCommon,
        }}
      >
        {prospectDetails.status == "In market" ? (
          <div
            style={{
              backgroundColor: "gray",
              borderRadius: "5px",
              border: "1px solid lightgray",
              height: "100%",
              width: "100%",
              ...commonStyle,
              flexDirection: "column",
              cursor: "pointer",
            }}
            onClick={() => {
              //navigate(`/binder?id=${prospectid}`)
              document.location.href = `/binder?id=${prospectid}`;
            }}
          >
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Name}
                textColor="white"
                fontSize={15}
              ></ClientDetailsGeneral>
            </div>
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Business_name}
                textColor="white"
                fontSize={10}
              ></ClientDetailsGeneral>
            </div>
          </div>
        ) : (
          <div />
        )}
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.fifth,
          ...borderCommon,
        }}
      >
        {prospectDetails.status == "Quoted" ? (
          <div
            style={{
              backgroundColor: "gray",
              borderRadius: "5px",
              border: "1px solid lightgray",
              height: "100%",
              width: "100%",
              ...commonStyle,
              flexDirection: "column",
              cursor: "pointer",
            }}
            onClick={() => {
              //navigate(`/binder?id=${prospectid}`)
              document.location.href = `/binder?id=${prospectid}`;
            }}
          >
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Name}
                textColor="white"
                fontSize={15}
              ></ClientDetailsGeneral>
            </div>
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Business_name}
                textColor="white"
                fontSize={10}
              ></ClientDetailsGeneral>
            </div>
          </div>
        ) : (
          <div />
        )}
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.sixth,
          ...borderCommon,
        }}
      >
        {prospectDetails.status == "Sold" ? (
          <div
            style={{
              backgroundColor: "gray",
              borderRadius: "5px",
              border: "1px solid lightgray",
              height: "100%",
              width: "100%",
              ...commonStyle,
              flexDirection: "column",
              cursor: "pointer",
            }}
            onClick={() => {
              //navigate(`/binder?id=${prospectid}`)
              document.location.href = `/binder?id=${prospectid}`;
            }}
          >
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Name}
                textColor="white"
                fontSize={15}
              ></ClientDetailsGeneral>
            </div>
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Business_name}
                textColor="white"
                fontSize={10}
              ></ClientDetailsGeneral>
            </div>
          </div>
        ) : (
          <div />
        )}
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.seventh,
          ...borderCommon,
        }}
      >
        {prospectDetails.status == "Close - Incomplete Info" ? (
          <div
            style={{
              backgroundColor: "gray",
              borderRadius: "5px",
              border: "1px solid lightgray",
              height: "100%",
              width: "100%",
              ...commonStyle,
              flexDirection: "column",
              cursor: "pointer",
            }}
            onClick={() => {
              //navigate(`/binder?id=${prospectid}`)
              document.location.href = `/binder?id=${prospectid}`;
            }}
          >
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Name}
                textColor="white"
                fontSize={15}
              ></ClientDetailsGeneral>
            </div>
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Business_name}
                textColor="white"
                fontSize={10}
              ></ClientDetailsGeneral>
            </div>
          </div>
        ) : (
          <div />
        )}
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.eighth,
          ...borderCommon,
        }}
      >
        {prospectDetails.status == "Close - No Insurer" ? (
          <div
            style={{
              backgroundColor: "gray",
              borderRadius: "5px",
              border: "1px solid lightgray",
              height: "100%",
              width: "100%",
              ...commonStyle,
              flexDirection: "column",
              cursor: "pointer",
            }}
            onClick={() => {
              navigate(`/binder?id=${prospectid}`);
              //document.location.href = `/binder?id=${prospectid}`;
            }}
          >
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Name}
                textColor="white"
                fontSize={15}
              ></ClientDetailsGeneral>
            </div>
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Business_name}
                textColor="white"
                fontSize={10}
              ></ClientDetailsGeneral>
            </div>
          </div>
        ) : (
          <div />
        )}
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.ninth,
        }}
      >
        {prospectDetails.status == "Not Interested" ? (
          <div
            style={{
              backgroundColor: "gray",
              borderRadius: "5px",
              border: "1px solid lightgray",
              height: "100%",
              width: "100%",
              ...commonStyle,
              flexDirection: "column",
              cursor: "pointer",
            }}
            onClick={() => {
              //navigate(`/binder?id=${prospectid}`)
              document.location.href = `/binder?id=${prospectid}`;
            }}
          >
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Name}
                textColor="white"
                fontSize={15}
              ></ClientDetailsGeneral>
            </div>
            <div>
              <ClientDetailsGeneral
                prospectDetails={prospectDetails}
                ClientDetailPartName={Client_Business_name}
                textColor="white"
                fontSize={10}
              ></ClientDetailsGeneral>
            </div>
          </div>
        ) : (
          <div />
        )}
      </div>
    </div>
  );
};

//#region Right Pane
const MyBindersRightPane = (props) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const useStyles = makeStyles({
    datePicker: {
      "& .MuiInputBase-root": {
        padding: 0,
        backgroundColor: "#ffffff",
        width: "12.5vw",
        "& .MuiButtonBase-root": {
          padding: 0,
          paddingRight: 10,
          backgroundColor: "#ffffff",
        },
        "& .MuiInputBase-input": {
          padding: 10,
          paddingLeft: 10,
          backgroundColor: "#ffffff",
        },
      },
    },
  });
  const classes = useStyles();
  const options = [
    {
      value: "week",
      label: { en: "This Week", fr: "Cette semaine" },
    },
    {
      value: "month",
      label: { en: "This Month", fr: "Ce mois-ci" },
    },
    {
      value: "year",
      label: { en: "This Year", fr: "Cette année" },
    },
    {
      value: "custom",
      label: { en: "Custom", fr: "Personnalisé" },
    },
  ];
  const brokers = useSelector(getBrokers);
  const statuses = useSelector(getStatus);
  const verticals = useSelector(getVertical);
  const userInformation = useSelector(getBrokerInformation);
  const languagepreference = userInformation?.information?.languagepreference || "en";
  const locale = languagepreference === "fr" ? frLocale : enLocale;

  const boptions = [];
  for (const b of brokers) {
    boptions.push({ value: b, label: b });
  }
  const soptions = [];
  for (const b of statuses) {
    soptions.push({ value: b, label: b.replace("new", "New") });
  }
  const voptions = [];
  const uniquevs = [];
  // Function to get translated options
  const getTranslatedDateOptions = (langPref) => {
    return options.map((option) => ({
      value: option.value,
      label: option.label[langPref] || option.label.en, // Fallback to English
    }));
  };
  for (const b of verticals) {
    if (!uniquevs.includes(b[languagepreference])) {
      uniquevs.push(b[languagepreference]);
      voptions.push({
        value: b[languagepreference],
        label: b[languagepreference],
      });
    }
  }

  const [isCustomDate, setIsCustomDate] = useState(false);
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        padding: "3vw",
        justifyContent: "center",
        alignItems: "center",
        fontFamily: "GibsonLight",
        color: "grey",
      }}
    >
      <div>
        <Typography
          variant="h5"
          component="h5"
          style={{
            fontFamily: "GibsonSemiBd",
            fontSize: 26,
            color: theme.COLORS.primary_navyblue,
          }}
        >
          {translations[languagepreference]?.filters.header ||
            translations["en"].filters.header}
        </Typography>
      </div>
      {loading ? (
        <div
          style={{
            width: "100%",
          }}
        >
          <Loader3Orange />
        </div>
      ) : (
        <div />
      )}
      <FormControl sx={{ m: 0, minWidth: 260 }} style={{ marginTop: "20px" }}>
        <div>
          <input
            id="txtQuery"
            placeholder={
              translations[languagepreference]?.form
                .searchForClientPlaceholder ||
              translations["en"].form.searchForClientPlaceholder
            }
            style={{
              backgroundColor: "#ffffff",
              width: "80%",
              display: "inline-flex",
              borderStartEndRadius: "0px",
              borderEndEndRadius: "0px",
            }}
            className="form-control"
            onChange={(event) => {
              props.setQuery(event.target.value);
            }}
          />
          <div
            style={{
              display: "inline-flex",
              paddingLeft: "3.5%",
              paddingTop: "6px",
              paddingRight: "3.5%",
              backgroundColor: theme.COLORS.secondary_orange,
              borderStartEndRadius: "5px",
              borderEndEndRadius: "5px",
            }}
          >
            <label
              onClick={(event) => {
                setLoading(true);
                dispatch(searchProspects(props.query)).then(() =>
                  setLoading(false)
                );
              }}
            >
              🔍
            </label>
          </div>
        </div>
      </FormControl>
      <div style={{ marginTop: "20px" }}>
        <Typography
          variant="h5"
          component="h5"
          style={{
            fontFamily: "GibsonSemiBd",
            fontSize: 20,
            color: theme.COLORS.secondary_orange,
          }}
        >
          {translations[languagepreference]?.filters.dateHeader ||
            translations["en"].filters.dateHeader}
        </Typography>
        <FormControl variant="filled" sx={{ m: 1, minWidth: 300 }}>
          <Select
            options={getTranslatedDateOptions(languagepreference)}
            // placeholder={
            //   translations[languagepreference]?.filters
            //     .selectPaymentMethodPlaceholder ||
            //   translations["en"].filters.selectPaymentMethodPlaceholder
            // }
            placeholder={translations[languagepreference].select}
            style={{
              width: "12.5vw",
              backgroundColor: "#ffffff",
              borderRadius: "5px",
            }}
            onChange={(e) => {
              var today = new Date();
              var pastWeek = new Date();
              var pastMonth = new Date();
              var pastYear = new Date();
              pastWeek.setDate(pastWeek.getDate() - 7);
              pastMonth.setDate(pastMonth.getDate() - 30);
              pastYear.setDate(pastYear.getDate() - 365);
              if (e.length === 0) {
                props.setStartDateFilter(null);
                props.setEndDateFilter(null);
                setIsCustomDate(false);
              } else if (e[0].value === "week") {
                props.setStartDateFilter(pastWeek);
                props.setEndDateFilter(today);
                setIsCustomDate(false);
              } else if (e[0].value === "month") {
                props.setStartDateFilter(pastMonth);
                props.setEndDateFilter(today);
                setIsCustomDate(false);
              } else if (e[0].value === "year") {
                props.setStartDateFilter(pastYear);
                props.setEndDateFilter(today);
                setIsCustomDate(false);
              } else if (e[0].value === "custom") {
                setIsCustomDate(true);
              }
            }}
          />
        </FormControl>
        <div style={{ width: "250px" }}>
          {isCustomDate ? (
            <div>
              <div>
                <p style={{ margin: "0px", marginTop: "5px" }}>
                  {translations[languagepreference]?.form.fromLabel || "From"}
                </p>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                  <KeyboardDatePicker
                    className={classes.datePicker}
                    inputVariant="filled"
                    value={props.startDateFilter}
                    placeholder={
                      languagepreference === "fr" ? "jj/mm/aaaa" : "mm/dd/yyyy"
                    }
                    cancelLabel={translations[languagepreference].cancel}
                    format="MMM dd, yyyy"
                    onChange={(e) => {
                      props.setStartDateFilter(e);
                    }}
                  />
                </MuiPickersUtilsProvider>
              </div>
              <div>
                <p style={{ margin: "0px" }}>
                  {translations[languagepreference]?.form.toLabel || "To"}
                </p>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    className={classes.datePicker}
                    inputVariant="filled"
                    value={props.endDateFilter}
                    minDate={props.startDateFilter}
                    format="MMM dd, yyyy"
                    onChange={(e) => {
                      props.setEndDateFilter(e);
                    }}
                  />
                </MuiPickersUtilsProvider>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
      <div style={{ marginTop: "20px" }}>
        <Typography
          variant="h5"
          component="h5"
          style={{
            fontFamily: "GibsonSemiBd",
            fontSize: 20,
            color: theme.COLORS.secondary_orange,
          }}
        >
          {translations[languagepreference]?.filters.statusHeader ||
            translations["en"].filters.statusHeader}
        </Typography>
        <FormControl variant="filled" sx={{ m: 1, minWidth: 300 }}>
          <Select
            placeholder={translations[languagepreference].select}
            options={ 
              getTranslatedOptions(statusOptionList, languagepreference)
              }
            style={{
              width: "12.5vw",
              backgroundColor: "#ffffff",
              borderRadius: "5px",
            }}
            onChange={(e) => {
              if (e.length === 0) {
                props.setStatusFilter("");
              } else {
                props.setStatusFilter(e[0].value);
              }
            }}
          />
        </FormControl>
      </div>
      <div style={{ marginTop: "20px" }}>
        <Typography
          variant="h5"
          component="h5"
          style={{
            fontFamily: "GibsonSemiBd",
            fontSize: 20,
            color: theme.COLORS.secondary_orange,
          }}
        >
          {translations[languagepreference]?.filters.verticalHeader ||
            translations["en"].filters.verticalHeader}
        </Typography>
        <FormControl variant="filled" sx={{ m: 1, minWidth: 300 }}>
          <Select
            placeholder={translations[languagepreference].select}
            options={voptions}
            style={{
              width: "12.5vw",
              backgroundColor: "#ffffff",
              borderRadius: "5px",
            }}
            onChange={(e) => {
              if (e.length) {
                props.setVerticalFilter(e[0].value);
              } else {
                props.setVerticalFilter("");
              }
            }}
          />
        </FormControl>
      </div>
      <div style={{ marginTop: "20px" }}>
        <Typography
          variant="h5"
          component="h5"
          style={{
            fontFamily: "GibsonSemiBd",
            fontSize: 20,
            color: theme.COLORS.secondary_orange,
          }}
        >
          {translations[languagepreference]?.filters.brokerHeader ||
            translations["en"].filters.brokerHeader}
        </Typography>
        <FormControl variant="filled" sx={{ m: 1, minWidth: 300 }}>
          <Select
            placeholder={translations[languagepreference].select}
            options={boptions}
            style={{
              width: "12.5vw",
              backgroundColor: "#ffffff",
              borderRadius: "5px",
            }}
            onChange={(e) => {
              if (e.length === 0) {
                props.setBrokerFilter("");
              } else {
                props.setBrokerFilter(e[0].value);
              }
            }}
          />
        </FormControl>
      </div>
      <div style={{ marginTop: "20px" }}>
        <OrangeButton
          text={
            translations[languagepreference]?.filters.clearFiltersButton ||
            "Clear Filters"
          }
          width="12.5vw"
          onClick={(e) => {
            window.location.reload(false);
          }}
        />
      </div>
    </div>
  );
};

export default BindPolicies;
